import { useEffect, useRef, useState } from 'react';
import { BASE_API } from '../lib/utilities';

import axios from 'axios';

const useGetURLContentType = ({ url }) => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const errorTracker = useRef(false);
  useEffect(() => {
    let isSubscribed = true;
    if (url) {
      setLoading(true);
      const getContentType = async () => {
        try {
          if (isSubscribed) {
            const response = await axios.get(`${BASE_API}/integration/facebook/proxy`, { params: { url }, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
            const { data } = response;
            if (response.status === 200) {
              setData(((data || {}).data || {})['content-type']);
              setLoading(false);
            }
          }
        } catch (error) {
          errorTracker.current = true;
          setData('error');
          setLoading(false);
        }
      };

      getContentType();
    }
    return () => (isSubscribed = false);
  }, [url]);

  if (errorTracker.current === true) {
    return { contentType: 'error', contentTypeLoading: false };
  }
  return { contentType: !url ? undefined : data, contentTypeLoading: !url ? false : loading };
};

export { useGetURLContentType };
